import { render, staticRenderFns } from "./AboutTheProgram.vue?vue&type=template&id=b09e4b86&scoped=true"
import script from "./AboutTheProgram.vue?vue&type=script&lang=js"
export * from "./AboutTheProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09e4b86",
  null
  
)

export default component.exports